import { TextField } from "@material-ui/core";
import React from "react";

interface Props {
  value: string;
  onChange: (value: string) => void;
}

const InvoiceNumberInput: React.FC<Props> = ({ value, onChange }) => (
  <TextField
    label="Invoice Number"
    value={value}
    variant="filled"
    onChange={(e) => onChange(e.target.value)}
    autoFocus
    fullWidth
  />
);

export default InvoiceNumberInput;
